const privileges = {
  DIV_PRIV_READ: 'DIV_PRIV_READ',
  DIV_PRIV_VEHICLE_ADMIN: 'DIV_PRIV_VEHICLE_ADMIN',
  DIV_PRIV_USER_ADMIN: 'DIV_PRIV_USER_ADMIN',
};

export default privileges;
